import Axios from "axios";

class OperacaoPendenteTransacaoDataService {
  getAll() {
    return Axios.get("operacoesPendentes/transacoes");
  }

  getPage(params) {
    return Axios.get("operacoesPendentes/transacoes/page", { params });
  }

  getFilterPage(payload, params) {
    return Axios.post("operacoesPendentes/transacoes/filter/page", payload, {
      params,
    });
  }

  find(id) {
    return Axios.get(`operacoesPendentes/transacoes/${id}`);
  }

  executar(id) {
    return Axios.post(`operacoesPendentes/transacoes/${id}/executar`).then(
      (response) => {
        if (response?.data?.sucesso) {
          return response;
        }

        const error = new Error(
          response?.data?.mensagem || "A transacao nao foi concluida."
        );
        error.response = {
          data: {
            message: error.message,
          },
        };
        throw error;
      }
    );
  }
}

export default new OperacaoPendenteTransacaoDataService();
